import React from 'react'
import { cx, css } from 'linaria'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

import blurredBg from './blurred-bg.png'
import { ReactComponent as Productivity1Icon } from './productivity-1.svg'
import { ReactComponent as Productivity2Icon } from './productivity-2.svg'
import { ReactComponent as Productivity3Icon } from './productivity-3.svg'
import { ReactComponent as Productivity4Icon } from './productivity-4.svg'
import { ReactComponent as CheckIconSvg } from '@components/svg/check-icon.svg'
import demoVideo from '@/assets/video/demo-blurred.mp4'
import DemoOnMac from '@ui/demo-on-mac'

import { CircleIconList, CircleIconListItem } from '@ui/circle-icon-list'

const circleIconList: CircleIconListItem[] = [
  { text: 'Distraction-free', Img: Productivity1Icon },
  { text: 'Be mindful', Img: Productivity2Icon },
  { text: 'Single-tasking setup', Img: Productivity3Icon },
  { text: 'Productivity boost', Img: Productivity4Icon },
]

const productivityList: string[] = [
  'Focus on one thing at the time',
  'Forget about having to minimize, close, or hide windows to keep your Desktop sane.',
  'Spend less time managing windows. Window clutter will no longer bother you.',
]

export const Intro = () => {
  const data = useStaticQuery(graphql`
    query {
      settingImg: file(relativePath: { eq: "blurred/setting.png" }) {
        childImageSharp {
          fluid(maxWidth: 523) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  `)
  const sources = [data?.settingImg?.childImageSharp.fluid]

  return (
    <>
      <section
        className={cx(
          css`
          padding-top: 7.5rem;
          background: url(${blurredBg}) no-repeat center top;
          background-size: cover;
          padding-bottom 20%;
        `
        )}
      >
        <div
          className={cx(
            'container px-4',
            css`
              max-width: 49.5rem;
            `
          )}
        >
          <h2 className="text-section-title text-center mb-6">Productivity matters.</h2>
          <div className="text-section-content text-center mb-20">
            {`During the workday, we have to open a few applications, but not all of them bring you the feel to productivity. They cause us to struggle with distraction and context switching, which leads to mental health damage and loss of productivity. We believe that focusing only on one thing at the time will boost your productivity and keep us mindful.`}
          </div>
          <CircleIconList
            className="mb-10 md:mb-20"
            circleIconList={circleIconList}
            circleIconListemItemClassName={css`
              background: linear-gradient(180deg, #209ae6 0%, #d51d58 108.92%);
            `}
          />
        </div>
      </section>
      <section
        className={cx(
          'z-10 relative pb-15',
          css`
            margin-top: -20%;
          `
        )}
      >
        <div className="container px-4">
          <DemoOnMac src={demoVideo} />
        </div>
      </section>
      <section className="section">
        <div className="container px-4">
          <div className="flex justify-between flex-wrap items-center -mx-4 flex-row-reverse">
            <div className="md:w-2/5 max-w-98 px-4">
              <ul className="list-reset">
                {productivityList.map((item, idx) => (
                  <li key={item} className={cx('flex', idx !== 0 && 'mt-5 md:mt-10')}>
                    <CheckIconSvg className={cx('flex-none mt-1 md:mt-2')} />
                    <span
                      className={cx(
                        'ml-5 block text-lg',
                        css`
                          font-weight: 500;
                          @screen md {
                            font-size: 26px;
                            font-weight: 600;
                          }
                        `
                      )}
                    >
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <div
              className={cx(
                'px-4 w-full md:w-3/5',
                css`
                  @screen md {
                    max-width: 555px;
                  }
                `
              )}
            >
              <Img fluid={sources} />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Intro
